/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./HousekeepingContent2.css";

/* ==== IMAGES (use real icons here) ==== */
import IconTrusted from "../../Image/HouseKeeping/Housekeeping1.png";
import IconCoverage from "../../Image/HouseKeeping/Housekeeping1.png";
import IconCompliance from "../../Image/HouseKeeping/Housekeeping1.png";


const CorporatePestControlContent = () => {
  return (
    <div>
    <section className="hk2-wrapper">

      {/* TAG */}
      <div className="hk2-tag">About This Service</div>

      {/* TITLE */}
      <h2 className="hk2-title">Corporate Pest Control Services</h2>
      <div className="hk2-underline"></div>

      {/* CONTENT BOX */}
      <div className="hk2-box">
        <p>
         We offer pest control services for offices, residential societies (not inside homes), warehouses and industrial units. Our treatments target cockroaches, rodents, termites and other pests using safe, approved chemicals and modern pest management techniques.
        </p>

        <p>
         General pest control plus targeted treatments designed specifically for offices and industrial spaces. Regular pest control helps maintain hygiene standards, protects property from damage, and creates a healthier workplace environment free from disease-carrying pests.
        </p>

        <p>
          Our integrated pest management approach combines preventive measures, targeted treatments, and ongoing monitoring for effective long-term pest control and prevention.
        </p>
      </div>

      {/* ICON 3 CARDS (IMAGE LEFT, TEXT RIGHT) */}
      <div className="hk2-icons">

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconTrusted} className="hk2-icon-img" alt="Trusted Service" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Trusted Service</h4>
            <p>Since 2019</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCoverage} className="hk2-icon-img" alt="Coverage" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Coverage</h4>
            <p>15 Cities</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCompliance} className="hk2-icon-img" alt="Compliance" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Compliance</h4>
            <p>100% Certified</p>
          </div>
        </div>

      </div>

    </section>
   
    </div>
  );
};

export default CorporatePestControlContent;
